/**
 * Anpassningsbart tilläggsavtal till lokalhyresavtal (clean_tillagg_lokal v1,
 * ADR-0061): the standard frame — parties + Avtalskoppling — around a body of
 * user-authored custom sections, with optional signing.
 */
import { customSectionsBlockDefinition, fieldsSection, partyDetailsBlock, propertySlot, signingBlockDefinition, slotText } from '../common/index.js';
import { letterhead } from '../common/shared.js';
const K = 'clean_tillagg_lokal';
export const DEFAULT_DOCUMENT_TITLE = 'Tilläggsavtal till lokalhyresavtal';
/** Clean letterhead (legacy `CleanLetterhead`): the user's title, no form number. */
export const cleanLetterhead = {
    blockKey: `${K}.letterhead`,
    version: 'v1',
    plane: 'shared',
    status: 'published',
    language: 'sv-SE',
    title: 'Sidhuvud',
    summary: 'Repeating page header carrying the user-chosen document title and no form number.',
    slots: [
        {
            key: 'document_title',
            label: 'Dokumenttitel',
            type: 'text',
            required: true,
            default: DEFAULT_DOCUMENT_TITLE,
            help: 'Visas överst i dokumentet och blir avtalets namn.',
        },
    ],
    compile: (input, ctx) => letterhead.compile({ title: slotText(input.document_title) ?? DEFAULT_DOCUMENT_TITLE }, ctx),
};
export const hyresvard = partyDetailsBlock({
    blockKey: `${K}.hyresvard`,
    ref: 'hyresvard',
    title: 'Hyresvärd',
    summary: 'The landlord: name and organisation number.',
    role: 'lessor',
    fields: [
        { key: 'landlord_name', label: 'Namn', field: 'name', required: true },
        { key: 'landlord_org_number', label: 'Organisationsnummer', field: 'legalId' },
    ],
});
export const hyresgast = partyDetailsBlock({
    blockKey: `${K}.hyresgast`,
    ref: 'hyresgast',
    title: 'Hyresgäst',
    summary: 'The tenant: name and organisation number.',
    role: 'lessee',
    fields: [
        { key: 'tenant_name', label: 'Namn', field: 'name', required: true },
        { key: 'tenant_org_number', label: 'Organisationsnummer', field: 'legalId' },
    ],
});
const FROM_PROPERTY = 'Förifylls från hyresavtalets fastighet.';
export const avtalskoppling = fieldsSection({
    blockKey: `${K}.avtalskoppling`,
    ref: 'avtalskoppling',
    title: 'Avtalskoppling',
    summary: 'Which lokalhyresavtal and premises the supplement belongs to.',
    rows: [
        {
            slot: {
                key: 'contract_number',
                label: 'Hyreskontrakt nr',
                type: 'text',
                required: true,
                derivedFromParent: true,
                help: 'Numret på det lokalhyresavtal som tillägget avser. Förifylls från avtalet.',
            },
        },
        { slot: propertySlot('property_designation', 'Fastighetsbeteckning', 'designation', { help: FROM_PROPERTY }) },
        { slot: propertySlot('property_municipality', 'Kommun', 'municipality', { help: FROM_PROPERTY }) },
        { slot: propertySlot('property_address', 'Lokalens adress', 'address', { type: 'textarea', help: FROM_PROPERTY }) },
    ],
});
export const customSections = customSectionsBlockDefinition(`${K}.custom-sections`);
export const underskrifter = signingBlockDefinition({
    blockKey: `${K}.underskrifter`,
    slots: [
        {
            key: 'include_signing',
            label: 'Inkludera signering',
            type: 'boolean',
            default: true,
            help: 'Av: dokumentet exporteras utan underskrift. På: undertecknas av parterna.',
        },
    ],
});
export const CLEAN_TILLAGG_LOKAL_BLOCKS = [cleanLetterhead, hyresvard, hyresgast, avtalskoppling, customSections, underskrifter];
//# sourceMappingURL=blocks.js.map